<template>
  <div class="mb-12" :data-section-id="section.id">
    <h3 class="text-2xl font-bold text-gray-800 mb-6 pb-3 border-b-2 border-blue-500">
      {{ section.title }}
    </h3>

    <!-- Add this new block for direct section items -->
    <div v-if="section.items?.length" class="space-y-4 mb-6">
      <ChecklistItem
        v-for="item in section.items"
        :key="item.id"
        :item="item"
        :sectionTitle="section.title"
        @update-item="updateItem"
      />
    </div>

    <!-- Group subsections -->
    <div class="space-y-8">
      <SubsectionComponent
        v-for="subsection in section.subsections"
        :key="subsection.id"
        :subsection="subsection"
        :sectionTitle="section.title"
        @update-item="updateItem"
      />
    </div>
  </div>
</template>

<script>
import ChecklistItem from './ChecklistItem.vue';
import SubsectionComponent from './SubsectionComponent.vue';

export default {
  name: 'SectionComponent',
  components: {
    ChecklistItem,
    SubsectionComponent
  },
  props: {
    section: {
      type: Object,
      required: true
    }
  },
  emits: ['update-item'],
  methods: {
    updateItem(item) {
      this.$emit('update-item', item);
    }
  }
};
</script>
